import { Tooltip } from '@mui/material';
import { Warning as WarningIcon } from '@mui/icons-material';
import { useGetCurrentUser } from '@/hooks/api/users/useGetCurrentUser';
import { AssetPageObjectModel } from '@/poms/assetPageObjectModel';

export const MissingDependencyIcon = ({ hideTooltip }: { hideTooltip?: boolean }) => {
  const { permissions } = useGetCurrentUser();

  const tooltipText = `This asset is missing dependencies. ${permissions.canUploadAssets ? 'Upload the missing files to resolve.' : ''}`;

  return (
    <Tooltip data-testid={AssetPageObjectModel.MissingDependenciesWarningIcon} title={hideTooltip ? '' : tooltipText}>
      <WarningIcon
        sx={{
          color: 'warning.main',
          fontSize: '16px',
          flexShrink: 0,
        }}
      />
    </Tooltip>
  );
};
